import { logWrapper } from '../utils';

export default function reflect(runtimeConstant) {
  function run() {
    try {
      return function (input, path) {
        if (input === null || input === undefined || path === undefined) {
          return '';
        }

        var properties = path.indexOf('.') >= 0 ? path.split('.') : [path];
        var value = input;

        properties.forEach(function (p) {
          var isFunction = p.indexOf('()') === p.length - 2;
          var res = value[p.replace('()', '')];

          if (isFunction) {
            value = res.call(input);
          } else {
            value = res;
          }
        });

        return value;
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  // Wrap the setup function with logWrapper for debugging purposes
  return logWrapper(run, runtimeConstant.isDebugFilters)();
}
